// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DJAVG73aooRWXUBFeJZc{flex-direction:column;gap:24px;display:flex}.JRY2cSz5MaPWZwRIMd2U{flex-direction:column;gap:4px;margin-bottom:20px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DJAVG73aooRWXUBFeJZc`,
	"greetingHeader": `JRY2cSz5MaPWZwRIMd2U`
};
export default ___CSS_LOADER_EXPORT___;
